import React from "react";
import ReactDOM from "react-dom/client";
import "./_assets/styles/index.scss";
import App from "./app/App";
import reportWebVitals from "./app/reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./_helpers";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
